export default __webpack_public_path__ + "static/media/image.122faf8c.jpg";